import { Validators } from '@angular/forms';
import { NgxLoggerLevel } from 'ngx-logger';
import { BaseField, ControlName, Pagination, TableConfigs } from 'prg-core-lib';

const DEFAULT_CACHE_TIME = 3600;
export const commonEnv = {
  coreModuleConfigurations: {
    baseUrl: 'https://localhost:7226/',
    urlAPiPath: '/api',
    authApiPaths: {
      login: 'Authentication',
      tokenValidation: 'Authentication',
      register: 'Authentication/Register',
      simpleRegister: 'Authentication/SimpleRegister',
      confirmationAccount: 'Authentication/ConfirmationAccount',
      emailConfirmation: 'Authentication/EmailConfirmation',
      requestPassword: 'Authentication/RequestPasswordReset',
      resetPassword: 'Authentication/ResetPassword',
    },
    queryApiPaths: {
      create: 'Query',
      update: 'Query',
      getAll: 'Query/list',
      getById: 'Query/ById',
      executeQuery: 'Query/ExecuteQuery',
    },
    lookupTableApiPaths: {
      create: 'LookupTable',
      getAll: 'LookupTable',
      getLookupTableByIdWithItems: 'LookupTable/LookupTableByIdWithItems',
      items: {
        add: 'LookupTable/AddLookupItem',
      },
    },
    userManagementApiPaths: {
      getUserById: 'User/ByIdWithRolesScopes',
      getUsersByRole: 'User/ByRole',
      createUser: 'User',
      updateUser: 'User/UpdateRolesAndScopes',
      getAllRoles: 'Role/WithScopes',
      createRole: 'Role',
      updateRole: 'Role',
    },
    entityTypeApiPaths: {
      getAll: 'EntityType',
      createEntityType: 'EntityType',
      updateEntityTypePut: 'EntityType',
      getAllEntityTypeWithOperation: 'EntityType/EntityTypeListWithOperation',
      entityTypeByName: 'EntityType/ByName',
      properties: {
        createProperty: 'EntityTypeProperty',
        updatePropertyPut: 'EntityTypeProperty',
        getAllByEntityTypeId: 'EntityTypeProperty/AllPropertiesByEntityTypeId',
        updateOrder: 'EntityTypeProperty/UpdateEntityTypePropertiesOrder',
      },
      attributes: {
        createAttribute: 'EntityTypeAttribute',
        updateAttributePut: 'EntityTypeAttribute',
        getAllByEntityTypeId: 'EntityTypeAttribute/AllAttributesByEntityTypeId',
        updateOrder: 'EntityTypeAttribute/UpdateEntityTypeAttributesORder',
      },
      operations: {
        createOperation: 'EntityTypeOperation',
        updateOperationPut: 'EntityTypeOperation',
        getAllByEntityTypeId: 'EntityTypeOperation/AllOperationsByEntityTypeId',
      },
    },
    stateModelApiPaths: {
      create: 'statemodel',
      update: 'statemodel',
      delete: 'statemodel',
      getAll: 'statemodel',
      getById: 'statemodel/byid',
      getByName: 'statemodel/byname',
      saveStateModelState: 'statemodel/savestatemodelstate',
      stateModelStatesOptions: 'statemodel/stateModelStatesOptions',
    },
    dashboardApiPaths: {
      create: 'dashboard',
      getById: 'dashboard/ById',
      getByName: 'dashboard/ByName',
      updateDashboard: 'dashboard/UpdateDashboard',
      getByUserId: 'dashboard/ByUserId',
    },
    configurationItemsApiPaths: {
      getAll: 'ConfigurationItems/list',
      updateMultipleDefaults: 'ConfigurationItems/UpdateDefaults/Multiple',
      updateMultiple: 'ConfigurationItems/Update/Multiple',
      getBypath: 'ConfigurationItems/ByPath',
    },
    dynamicForm: {
      formValueChangeDebounce: 500,
      inputValueChangeDebounce: 500,
    },
  },
  production: false,
  useMockServices: true,
  logLevel: NgxLoggerLevel.TRACE,
  serverLogLevel: NgxLoggerLevel.OFF,

  authModuleConfigurations: {
    useMockServices: false,
    authRoutingBasePath: 'auth',
    authRoutingSignupPath: 'signup',
    authRoutingLoginPath: 'login',
    authRoutingRequestPasswordPath: 'request-password',
    authRoutingResetPasswordPath: 'reset-password',
    authRoutingLoginOkRedirectPath: '',
    authRoutingLogoutPath: 'logout',
    termsOfUseRoutingPath: 'terms-of-use',
    authStorage: {
      storage: window.localStorage,
      keyStoredUserName: 'savedUserEmail',
      keyLoggedUser: 'loggedUser',
    },
    useDefaultRouting: true,
    cacheTime: DEFAULT_CACHE_TIME,
  },
  termsModuleConfigurations: {
    useMockServices: true,
    baseTermsTranslationKey: 'components.terms-conditions',
    termsOfUseRoutingPath: 'terms-of-use',
    useDefaultRouting: true,
    cacheTime: DEFAULT_CACHE_TIME,
  },

  dashboardModuleConfigurations: {
    useMockServices: false,
    dashboardRoutingBasePath: 'dashboard',
    dashboardConfigRoutingPath: 'config',
    dashboardDisplayRoutingPath: 'display',
    displayDashboard: 'view',
    useDefaultRouting: true,
    cacheTime: DEFAULT_CACHE_TIME,
  },

  configurationItemsModuleConfigurations: {
    useMockServices: false,
    configurationItemsRoutingBasePath: 'config-items',
    configurationItemsRoutingAdminPath: 'admin',
    configurationItemsRoutingUserPath: 'user-preferences',
    useDefaultRouting: true,
    cacheTime: DEFAULT_CACHE_TIME,
  },

  dynamicFormsConfigurations: {
    useMockServices: true,
    dynamicFormsBasePath: 'dynamic-forms',
  },

  entityTypeConfigurations: {
    useMockServices: false,
    entityTypeBasePath: 'entity-types',
    entityTypeTableColumns: [
      new BaseField({
        value: null,
        readonly: true,
        key: 'name',
        validators: [],
        basePathTranslation: 'entities',
      }),
      new BaseField({
        value: null,
        readonly: true,
        key: 'guiSettings',
        validators: [],
      }),
      new BaseField({
        value: null,
        readonly: true,
        key: 'universalState',
        validators: [],
      }),
    ],

    specificEntityTypeListConfigs: new TableConfigs({
      defaultColumns: ['id', 'name', 'stock', 'expiryDate'],
      globalFilterFields: ['name', 'description'],
      pagination: new Pagination(),
      multiSortMeta: [
        { field: 'name', order: -1 },
        { field: 'stock', order: -1 },
      ],
    }),
    useDefaultRouting: true,
    cacheTime: DEFAULT_CACHE_TIME,
  },
  lookupTableConfigurations: {
    useMockServices: false,
    lookupTableBasePath: 'lookup-table',
    lookupTableColumns: [
      new BaseField({
        controlName: ControlName.inputText,
        key: 'name',
        validators: [Validators.required],
        readonly: true,
      }),
      new BaseField({
        controlName: ControlName.inputText,
        key: 'description',
        validators: [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(50),
        ],
      }),
      new BaseField({
        controlName: ControlName.inputText,
        key: 'universalState',
        validators: [Validators.required],
      }),
    ],
    lookupTableItemsColumns: [
      new BaseField({
        controlName: ControlName.inputText,
        key: 'name',
        validators: [Validators.required],
        readonly: true,
      }),
      new BaseField({
        controlName: ControlName.inputText,
        key: 'description',
        validators: [Validators.required],
      }),
      new BaseField({
        controlName: ControlName.inputText,
        key: 'universalState',
        validators: [],
      }),
    ],
    useDefaultRouting: true,
    cacheTime: DEFAULT_CACHE_TIME,
  },
  queriesModuleConfigurations: {
    useMockServices: false,
    queriesRoutingPath: 'queries',
    queryTableColumns: [
      new BaseField({
        key: 'name',
        readonly: true,
        basePathTranslation: 'queries.fields',
      }),
      new BaseField({
        key: 'description',
        readonly: true,
        basePathTranslation: 'queries.fields',
      }),
      /*      new BaseField({
        key: 'isRaw',
        readonly: true,
        basePathTranslation: 'queries.fields',
      }),*/
      new BaseField({
        key: 'createdBy',
        readonly: true,
        basePathTranslation: 'queries.fields',
      }),
      /*    new BaseField({
        key: 'entityTypeId',
        readonly: true,
        basePathTranslation: 'queries.fields',
      }),*/
    ],
    useDefaultRouting: true,
    cacheTime: DEFAULT_CACHE_TIME,
  },
  stateModelsConfigurations: {
    useMockServices: false,
    stateModelsBasePath: 'state-models',
    stateModelsTableColumns: [
      new BaseField({
        controlName: ControlName.inputText,
        key: 'name',
        validators: [Validators.required],
        readonly: true,
      }),
      new BaseField({
        controlName: ControlName.inputText,
        key: 'universalState',
        validators: [Validators.required],
        readonly: true,
      }),
    ],
    useDefaultRouting: true,
    cacheTime: DEFAULT_CACHE_TIME,
  },
  userManagementModuleConfigurations: {
    useMockServices: false,
    userManagementBasePath: 'user-management',
    baseScopes: ['view', 'create', 'update', 'delete'],
    otherScopes: 'other',
    useDefaultRouting: true,
    cacheTime: DEFAULT_CACHE_TIME,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
